// @flow
import CCActionTypes from '../action-types/cc-mode';

import type { CCMode, Notification } from '../types/cc-mode';

export const addNotification = (notification: Notification) => ({
  type: CCActionTypes.ADD_NOTIFICATION,
  payload: notification,
});

export const clearNotifications = () => ({
  type: CCActionTypes.CLEAR_NOTIFICATIONS,
});

export const deleteNotification = (index: number) => ({
  type: CCActionTypes.DELETE_NOTIFICATION,
  payload: index,
});

// For the desktop app, when the conversation ends, we stay in this CC mode
// window. In order to handle resizing the window, there are 3 different modes
// to know which state the app is in.
export const setCCMode = (ccMode: CCMode) => ({
  type: CCActionTypes.SET_MODE,
  payload: ccMode,
});

// Used to know whether to display the participants and conversation buttons.
export const setShowBubbleAboveCCMode = (shouldShow: boolean) => ({
  type: CCActionTypes.SET_SHOW_BUBBLE_ABOVE_CC_MODE,
  payload: shouldShow,
});
